export default "__VITE_ASSET__C2HYXSs6__"